import { api } from "@/api/client";
import {
  menoSuboru,
  parametreVariant,
  triggerBlobDownload,
  type Varianty,
} from "@/lib/pdfDownload";

/**
 * Tabuľkový export dielcov — podklad pre pílu (KOLO 71).
 *
 * Na rozdiel od PDF výstupov sa **nezobrazuje náhľad**: `PdfNahladDialog`
 * renderuje PDF v iframe a tabuľku by v ňom prehliadač nezobrazil. Klik
 * teda súbor rovno stiahne.
 *
 * Formáty nesú ten istý obsah — XLSX na pozeranie v Exceli, CSV pre
 * softvér píly (viď `api/routers/export.py`).
 */

export type ExportFormat = "xlsx" | "csv";

const MIME: Record<ExportFormat, string> = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: "text/csv",
};

/**
 * Stiahne export dielcov zákazky v zadanom formáte. Viac variant = časti
 * za sebou s číslom časti v ID (`1-A1`, KOLO 206).
 */
export async function stiahniDielceExport(
  zakazkaId: string,
  cisloZakazky: string,
  format: ExportFormat,
  varianty?: Varianty,
): Promise<void> {
  const response = await api.get<Blob>(
    `/zakazky/${zakazkaId}/export/dielce.${format}`,
    {
      params: parametreVariant(varianty),
      responseType: "blob",
    },
  );
  // Meno zo servera by sa dalo prečítať z Content-Disposition, ale pri
  // blob requeste ho axios nemusí vydať (CORS/expose-headers), takže si
  // ho skladáme rovnako ako backend.
  triggerBlobDownload(
    response.data,
    `${menoSuboru(`dielce_${cisloZakazky}`, varianty)}.${format}`,
    MIME[format],
  );
}
